import sa from 'sa-sdk-javascript'
import browser from '@/util/browser'
import xhr from '@/util/xhr'

const randomString = (len) => {
    let result = ''
    const source = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
    for (let i = 0; i < len; i++) {
        const index = Math.floor(Math.random() * source.length)
        result += source.charAt(index)
    }
    return result
}

const SERVER_URL = 'https://sensorsdata.vipkid.com.cn/sa?project=qimeng'

const getEncodePath = () => {
    if (window.btoa) {
        return window.btoa(location.path)
    } else {
        return encodeURIComponent(location.path)
    }
}

sa.init({
    server_url: process.env.NODE_ENV === 'development' ? '' : SERVER_URL,
    debug_mode_upload: process.env.NODE_ENV !== 'production',
    cross_subdomain: false,
    is_track_single_page: true,
    show_log: process.env.NODE_ENV !== 'production'
})
sa.quick('autoTrack')

class LogService {
    constructor(engine, options = {}) {
        this.engine = engine
        this.register({
            product: 'qimeng',
            trigger_id: randomString(16),
            ...options
        })

        this.clickParamMap = new Map()
        this.globalParmasMap = new Map()

        this.defaultParmas = {
            type: browser.vkhybrid ? 'app' : 'h5'
        }
    }

    // 执行参数持久化
    register(params, isGlobal = true) {
        this.engine[isGlobal ? 'register' : 'registerPage'](params)
    }

    // 敏感信息脱敏
    encodeSensitiveInfo(numString) {
        const createRandomNum = (len) => {
            return Math.ceil(Math.random() * len)
        }
        let result = ''
        const numArr = numString.split('')
        const source = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
            // 手机号只用头10位表示 A:0 B:1 C:2
        while (numArr.length) {
            const num = numArr.shift()
            const isAddRandom = createRandomNum(source.length) >= 5
            if (/\d/.test(num)) {
                const interferCharacter = source.charAt(createRandomNum(source.length)).toLowerCase()
                result += [
                    isAddRandom ? interferCharacter : '',
                    source.charAt(num)
                ].join('')
            }
        }
        const randomOffset = [
            source.charAt(createRandomNum(source.length)),
            source.charAt(createRandomNum(source.length)).toLowerCase()
        ].join('')
        result = randomOffset + result
        return result
    }

    // 记录日志
    track(eventName, {
        eventId,
        params,
        options = {},
        custom = {}
    }) {
        const globalParmas = {}
        const enCodePathname = getEncodePath() || ''
        const getMapByName = (pathname) => {
            return this.globalParmasMap.get(pathname) || new Map()
        }
        const currentParamsMap = new Map([...getMapByName(enCodePathname), ...getMapByName('global')])
        for (const [key, value] of currentParamsMap.entries()) {
            globalParmas[key] = value
        }

        params = {
            ...this.defaultParmas,
            ...params,
            ...globalParmas
        }
        const { needBackup } = options
        return new Promise((resolve) => {
            needBackup && xhr.post('/rest/nezha-api/api/v1/nzcheese/marketing/addelivery/add?type=h5', {
                student_id: localStorage.getItem('studentId') || '',
                tm: new Date().getTime(),
                url: location.href,
                action_code: eventId
            })
            this.engine.track(eventName, {
                event_id: eventId,
                c_url: location.href,
                $url: location.href,
                event_content: JSON.stringify(params),
                ...custom
            }, () => {
                resolve()
            })
        })
    }

    // 添加固定参数
    // 原因: 因为现在没有功能组件很多没有业务打点参数.比如说快速登录组件没有商品信息 但是业务打点需要.所以就把这类打点参数添加到全局
    addCommonParams(params, isGlobal = false) {
        const enCodePathname = isGlobal ? 'global' : getEncodePath()
        const currentParamsMap = this.globalParmasMap.get(enCodePathname) || new Map()
        for (const i in params) {
            currentParamsMap.set(i, params[i])
        }
        this.globalParmasMap.set(enCodePathname, currentParamsMap)
    }

    pageClick(eventId, params = {}, options, custom = {}) {
        const { isReturnHandle } = options = Object.assign({
            isReturnHandle: false,
            needBackup: false
        }, options)
        const clickHanlde = randomString(16)
        if (isReturnHandle) {
            this.clickParamMap.set(clickHanlde, params)
        }
        this.track('page_click', {
            eventId,
            params,
            options,
            custom
        })
        return clickHanlde
    }

    /**
     * @description:pagetrigger表示pageClick执行的结果 每一个pageTrigger都对应一个pageClick
     * eventContent的参数可以和他对应的pageClick的eventContent合并
     * ex:如果pageClick传入了goodsId/goodsName/senderId之类的信息。pageTrigger只需要传入failReason 自动合并pageClick的其他参数
     * @param {params}<string> event_id
     * @param {options}<string> eventContent
     */
    pageTrigger(eventId, params, options, custom = {}) {
        const { clickHandle } = options = Object.assign({
            clickHandle: '',
            needBackup: false
        }, options)
        const defaultContent = this.clickParamMap.has(clickHandle) ? this.clickParamMap.get(clickHandle) : {}
        const newParams = { ...params, ...defaultContent }
        this.track('page_trigger', {
            eventId,
            params: newParams,
            options,
            custom
        })
    }
}

const install = (Vue, options) => {
    if (install.installed) {
        return
    }
    install.installed = true

    Vue.prototype.$logService = new LogService(sa, options)
}

export default {
    install
}
